import { environment } from '../../../environments/environment';

const readAssetBase = (): string => {
  if (typeof document === 'undefined') {
    return (environment.assetsPrefix ?? '').replace(/\/+$/, '');
  }

  const meta = document.querySelector('meta[name="asset-url"]') as HTMLMetaElement | null;
  const content = meta?.content?.trim();
  if (content) {
    return content.replace(/\/+$/, '');
  }

  return (environment.assetsPrefix ?? '').replace(/\/+$/, '');
};

const assetBase = readAssetBase();

export const assetUrl = (path: string): string => {
  const normalized = path.startsWith('/') ? path : `/${path}`;

  if (assetBase === '') {
    return normalized;
  }

  return `${assetBase}${normalized}`;
};
